import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilesListComponent } from './files-list/files-list.component';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PipesModule } from '../pipes/pipes.module';
import { FilesRemoveComponent } from './files-remove/files-remove.component';
import { FilesSelectorComponent } from './files-selector/files-selector.component';
import { ClipboardModule } from 'ngx-clipboard';

@NgModule({
    declarations: [
        FilesListComponent,
        FilesRemoveComponent,
        FilesSelectorComponent
    ],
    imports: [
        CommonModule,
        MatCardModule,
        MatListModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        MatBadgeModule,
        MatDialogModule,
        PipesModule,
      ClipboardModule
    ],
    exports: [FilesListComponent, FilesSelectorComponent]
})
export class FilesModule {}
